import { __awaiter } from "tslib";
import queryAnnotations from "../RcsbQueries/Borrego/QueryAnnotations.graphql";
import queryGroupAnnotationsSummary from "../RcsbQueries/Borrego/QueryGroupAnnotationsSummary.graphql";
import queryGroupAnnotations from "../RcsbQueries/Borrego/QueryGroupAnnotations.graphql";
export class RcsbQueryAnnotations {
    constructor(getClient) {
        this.getClient = getClient;
    }
    request(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const annotationsResponse = yield this.getClient().request(requestConfig, queryAnnotations);
                return annotationsResponse.annotations;
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        });
    }
}
export class RcsbQueryGroupAnnotationsSumary {
    constructor(getClient) {
        this.getClient = getClient;
    }
    request(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const annotationsResponse = yield this.getClient().request(requestConfig, queryGroupAnnotationsSummary);
                return annotationsResponse.group_annotations_summary;
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        });
    }
}
export class RcsbQueryGroupAnnotations {
    constructor(getClient) {
        this.getClient = getClient;
    }
    request(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const annotationsResponse = yield this.getClient().request(requestConfig, queryGroupAnnotations);
                return annotationsResponse.group_annotations;
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        });
    }
}
//# sourceMappingURL=RcsbQueryAnnotations.js.map